import { useRouteError, Link } from "react-router";
import axios from "axios";
import GeneralException from "components/exception/GeneralException";
import UnauthorizedException from "components/exception/UnauthorizedException";
import ApiException from "components/exception/ApiException";
import NoConnectionError from "components/exception/NoConnectionError";
import "components/exception/ErrorPage.css";

const ErrorPage = () => {
    const error = useRouteError();

    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            {axios.isAxiosError(error) === false ? (
                <GeneralException error={error} />
            ) : !error.response ? (
                <NoConnectionError />
            ) : error.response?.status === 401 ? (
                <UnauthorizedException />
            ) : error.response?.data["description"] ? (
                <ApiException error={error} />
            ) : (
                <GeneralException error={error} />
            )}
            <div style={{ marginTop: "30px" }}>
                <Link to="/" style={{ marginRight: "20px" }}>
                    Back to Home
                </Link>
                <a href="mailto:support@wishliz.com">Contact Support</a>
            </div>
        </div>
    );
};

export default ErrorPage;
